module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_750x90_1-6a19779580a7a7b1fdab583519adb4d3.jpg";